import { transformError as sdkTransformError } from '@wix/sdk-runtime/transform-error';
import { renameKeysFromSDKRequestToRESTRequest, renameKeysFromRESTResponseToSDKResponse, } from '@wix/sdk-runtime/rename-all-nested-keys';
import * as ambassadorWixBookingsReaderV2ExtendedBooking from './bookings-reader-v2-extended-booking-extended-bookings.http';
export var AttendanceStatus;
(function (AttendanceStatus) {
    AttendanceStatus["NOT_SET"] = "NOT_SET";
    AttendanceStatus["ATTENDED"] = "ATTENDED";
    AttendanceStatus["NOT_ATTENDED"] = "NOT_ATTENDED";
})(AttendanceStatus || (AttendanceStatus = {}));
export var MultiServiceBookingType;
(function (MultiServiceBookingType) {
    /**
     * Multi service booking will be considered available if its bookings are
     * available as returned from ListMultiServiceAvailabilityTimeSlots API.
     * See [List Multi Service Availability Time Slots] (url) documentation // todo: complete url
     */
    MultiServiceBookingType["SEQUENTIAL_BOOKINGS"] = "SEQUENTIAL_BOOKINGS";
    /**
     * Multi service booking will be considered available if each of its bookings is available separately.
     * Not supported yet
     */
    MultiServiceBookingType["SEPARATE_BOOKINGS"] = "SEPARATE_BOOKINGS";
    /** Not supported yet */
    MultiServiceBookingType["PARALLEL_BOOKINGS"] = "PARALLEL_BOOKINGS";
})(MultiServiceBookingType || (MultiServiceBookingType = {}));
export var LocationType;
(function (LocationType) {
    LocationType["UNDEFINED"] = "UNDEFINED";
    LocationType["OWNER_BUSINESS"] = "OWNER_BUSINESS";
    LocationType["OWNER_CUSTOM"] = "OWNER_CUSTOM";
    LocationType["CUSTOM"] = "CUSTOM";
})(LocationType || (LocationType = {}));
export var ValueType;
(function (ValueType) {
    /** Short text. This is the default value type. */
    ValueType["SHORT_TEXT"] = "SHORT_TEXT";
    /** Long text */
    ValueType["LONG_TEXT"] = "LONG_TEXT";
    /** a text that represent the check box value: if selected the value is "true", otherwise "false". */
    ValueType["CHECK_BOX"] = "CHECK_BOX";
})(ValueType || (ValueType = {}));
/** Booking status. */
export var BookingStatus;
(function (BookingStatus) {
    BookingStatus["CREATED"] = "CREATED";
    BookingStatus["CONFIRMED"] = "CONFIRMED";
    BookingStatus["CANCELED"] = "CANCELED";
    BookingStatus["PENDING"] = "PENDING";
    BookingStatus["DECLINED"] = "DECLINED";
    BookingStatus["WAITING_LIST"] = "WAITING_LIST";
})(BookingStatus || (BookingStatus = {}));
/**
 * Payment status.
 * Automatically updated when using eCom checkout APIs.
 */
export var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["UNDEFINED"] = "UNDEFINED";
    PaymentStatus["NOT_PAID"] = "NOT_PAID";
    PaymentStatus["PAID"] = "PAID";
    /** not supported yet. */
    PaymentStatus["PARTIALLY_PAID"] = "PARTIALLY_PAID";
    /** not supported yet */
    PaymentStatus["REFUNDED"] = "REFUNDED";
    PaymentStatus["EXEMPT"] = "EXEMPT";
})(PaymentStatus || (PaymentStatus = {}));
/**
 * The selected payment option.
 * One of the payment options offered by the service.
 * This field is be set when the user selects an option during booking.
 * If left undefined, the payment option is resolved by the service configuration on checkout.
 */
export var SelectedPaymentOption;
(function (SelectedPaymentOption) {
    SelectedPaymentOption["UNDEFINED"] = "UNDEFINED";
    SelectedPaymentOption["OFFLINE"] = "OFFLINE";
    SelectedPaymentOption["ONLINE"] = "ONLINE";
    SelectedPaymentOption["MEMBERSHIP"] = "MEMBERSHIP";
    /** Payment can only be done using a membership and must be manually redeemed in the dashboard by the site owner. */
    SelectedPaymentOption["MEMBERSHIP_OFFLINE"] = "MEMBERSHIP_OFFLINE";
})(SelectedPaymentOption || (SelectedPaymentOption = {}));
export var Platform;
(function (Platform) {
    Platform["UNDEFINED_PLATFORM"] = "UNDEFINED_PLATFORM";
    Platform["WEB"] = "WEB";
    Platform["MOBILE_APP"] = "MOBILE_APP";
})(Platform || (Platform = {}));
export var Actor;
(function (Actor) {
    Actor["UNDEFINED_ACTOR"] = "UNDEFINED_ACTOR";
    Actor["BUSINESS"] = "BUSINESS";
    Actor["CUSTOMER"] = "CUSTOMER";
})(Actor || (Actor = {}));
export var IdentityType;
(function (IdentityType) {
    IdentityType["UNKNOWN"] = "UNKNOWN";
    IdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    IdentityType["MEMBER"] = "MEMBER";
    IdentityType["WIX_USER"] = "WIX_USER";
    IdentityType["APP"] = "APP";
})(IdentityType || (IdentityType = {}));
export var BookingFeeStatus;
(function (BookingFeeStatus) {
    BookingFeeStatus["UNKNOWN_STATUS"] = "UNKNOWN_STATUS";
    BookingFeeStatus["NOT_YET_APPLIED_TO_ORDER"] = "NOT_YET_APPLIED_TO_ORDER";
    BookingFeeStatus["APPLIED_TO_ORDER"] = "APPLIED_TO_ORDER";
})(BookingFeeStatus || (BookingFeeStatus = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
/**
 * Retrieves a list of bookings, including additional extended information, given the provided paging, filtering, and sorting.
 *
 * Up to 100 extended bookings can be returned per request.
 *
 * `queryExtendedBookings()` runs with these defaults, which you can override:
 *
 * - `createdDate` sorted in `DESC` order
 * - `cursorPaging.limit` is `50`
 *
 *
 * You can retrieve information about which actions the customer can perform
 * for the bookings. To do so, pass `withBookingAllowedActions` as `true`.
 *
 *
 * For field support, see
 * [supported filters](https://www.wix.com/velo/reference/wix-bookings-v2/extendedbookings/supported-filters)
 * for more information.
 *
 * You can specify a filter only once per query. If you specify a filter
 * more than once, only the first filter determines the extended bookings that are returned.
 *
 * When filtering by date, you must use [UTC time](https://en.wikipedia.org/wiki/Coordinated_Universal_Time).
 * @public
 * @documentationMaturity preview
 * @requiredField query
 * @param query - Information about filters, paging, and sorting.
 * @param options - Additional options for performing the query.
 * @permissionId BOOKINGS.BOOKING_READ
 * @permissionId BOOKINGS.MANAGE_BOOKINGS
 * @permissionId BOOKINGS.BOOKING_READ_ANY
 * @permissionScope Manage Bookings
 * @permissionScopeId SCOPE.DC-BOOKINGS.MANAGE-BOOKINGS
 * @permissionScope Read Bookings - Including Participants
 * @permissionScopeId SCOPE.DC-BOOKINGS.READ-BOOKINGS-SENSITIVE
 * @permissionScope Read Bookings - all read permissions
 * @permissionScopeId SCOPE.DC-BOOKINGS-MEGA.READ-BOOKINGS
 * @permissionScope Manage Bookings - all permissions
 * @permissionScopeId SCOPE.DC-BOOKINGS-MEGA.MANAGE-BOOKINGS
 * @permissionScope Read bookings calendar - including participants
 * @permissionScopeId SCOPE.DC-BOOKINGS.READ-CALENDAR-WITH-PARTICIPANTS
 * @permissionScope Manage Bookings
 * @permissionScopeId SCOPE.DC-BOOKINGS.MANAGE-BOOKINGS
 * @permissionScope Manage Bookings - all permissions
 * @permissionScopeId SCOPE.DC-BOOKINGS-MEGA.MANAGE-BOOKINGS
 * @permissionScope Manage Bookings
 * @permissionScopeId SCOPE.DC-BOOKINGS.MANAGE-BOOKINGS
 * @permissionScope Read Bookings - Including Participants
 * @permissionScopeId SCOPE.DC-BOOKINGS.READ-BOOKINGS-SENSITIVE
 * @permissionScope Read Bookings - all read permissions
 * @permissionScopeId SCOPE.DC-BOOKINGS-MEGA.READ-BOOKINGS
 * @permissionScope Manage Bookings - all permissions
 * @permissionScopeId SCOPE.DC-BOOKINGS-MEGA.MANAGE-BOOKINGS
 * @applicableIdentity APP
 * @applicableIdentity VISITOR
 */
export async function queryExtendedBookings(query, options) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[2];
    const payload = renameKeysFromSDKRequestToRESTRequest({
        query: query,
        withBookingAllowedActions: options?.withBookingAllowedActions,
        withBookingAttendanceInfo: options?.withBookingAttendanceInfo,
        withBookingConferencingDetails: options?.withBookingConferencingDetails,
    });
    const reqOpts = ambassadorWixBookingsReaderV2ExtendedBooking.queryExtendedBookings(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return renameKeysFromRESTResponseToSDKResponse(result.data);
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: {
                query: '$[0]',
                withBookingAllowedActions: '$[1].withBookingAllowedActions',
                withBookingAttendanceInfo: '$[1].withBookingAttendanceInfo',
                withBookingConferencingDetails: '$[1].withBookingConferencingDetails',
            },
            singleArgumentUnchanged: false,
        }, ['query', 'options']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
//# sourceMappingURL=bookings-reader-v2-extended-booking-extended-bookings.universal.js.map